__turbopack_context__.v({
  "blue": "Divot-module-scss-module__DAb9mq__blue",
  "blueDark": "Divot-module-scss-module__DAb9mq__blueDark",
  "blueMedium": "Divot-module-scss-module__DAb9mq__blueMedium",
  "cream": "Divot-module-scss-module__DAb9mq__cream",
  "creamDark": "Divot-module-scss-module__DAb9mq__creamDark",
  "divot": "Divot-module-scss-module__DAb9mq__divot",
  "makersReserveBrown": "Divot-module-scss-module__DAb9mq__makersReserveBrown",
});
